import React, { Component } from "react";
import { StoryElement, ImageGalleryElement } from "@quintype/components";
import { object, number, string, bool } from "prop-types";
import get from "lodash/get";

import CustomImageGalleryElement from "./image-gallery";
import LightBox from "../../molecules/lightbox";
import AlsoRead from "../../molecules/also-read";
import GlideSlider from "../../molecules/glide-slider";

import "./story-card.m.css";

class StoryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideshowItems: [],
      galleryItemIndex: 0,
      showPopup: {}
    };
  }

  componentDidMount() {
    const slideshowItems = this.getSlideshowElements();
    this.setState({
      slideshowItems
    });
  }

  getSlideshowElements = () => {
    const galleryItems = this.props.card["story-elements"].filter(
      item => item.type === "composite" && item.metadata.type === "slideshow"
    );
    if (galleryItems.length > 0) {
      return get(galleryItems, ["0", "story-elements"], []);
    }
    return [];
  };

  togglePopup = (id, isPopupOpen, index = 0) => {
    this.setState({
      showPopup: {
        [id]: isPopupOpen
      },
      galleryItemIndex: index
    });
  };

  render() {
    const { slideshowItems } = this.state;
    const templates = {
      "also-read": AlsoRead
    };
    const getStoryElementDom = (element, index) => {
      return (
        <div className="story-element-image" key={index}>
          {element.type === "image" && this.props.template === "photo" ? (
            <div styleName="card-number">{`${element.imageIndex} / ${this.props.cardCount}`}</div>
          ) : null}

          <div onClick={() => element.type === "image" && this.togglePopup(element.id, true, index)}>
            <StoryElement
              renderTemplates={templates}
              story={this.props.story}
              key={element.id}
              element={element}
              externalLink={true}
            />
          </div>
          <div>
            {this.state.showPopup[element.id] ? (
              <LightBox element={element} closePopup={() => this.togglePopup(element.id, false)} />
            ) : null}
          </div>
        </div>
      );
    };

    return (
      <div styleName="wrapper" className="story-card">
        {this.props.card["story-elements"] &&
          this.props.card["story-elements"].map((element, index) => {
            switch (element.subtype) {
              case "image-gallery":
                if (element.metadata.type === "gallery") {
                  return (
                    <div key={index}>
                      {element.type === "composite" ? (
                        this.props.isEvent ? (
                          <CustomImageGalleryElement
                            story={this.props.story}
                            element={element}
                            key={element.id}
                            imageAspectRatio={[1, 1]}
                            onClickHandler={index => this.togglePopup(element.id, true, index)}
                          />
                        ) : (
                          <ImageGalleryElement
                            story={this.props.story}
                            element={element}
                            key={element.id}
                            imageAspectRatio={[1, 1]}
                            onClickHandler={index => this.togglePopup(element.id, true, index)}
                          />
                        )
                      ) : (
                        <StoryElement
                          renderTemplates={templates}
                          story={this.props.story}
                          element={element}
                          externalLink={true}
                        />
                      )}
                      <div>
                        {this.state.showPopup[element.id] ? (
                          <LightBox
                            element={element["story-elements"][this.state.galleryItemIndex]}
                            closePopup={() => this.togglePopup(element.id, false)}
                          />
                        ) : null}
                      </div>
                    </div>
                  );
                } else if (element.metadata.type === "slideshow" && slideshowItems.length) {
                  return (
                    <GlideSlider
                      key={index}
                      story={this.props.story}
                      totalItems={slideshowItems.length}
                      slideshowItems={slideshowItems}
                    />
                  );
                }
                break;

              default:
                return getStoryElementDom(element, index);
            }
          })}
      </div>
    );
  }
}

StoryCard.propTypes = {
  card: object,
  story: object,
  excludeElementId: string,
  index: number,
  cardCount: number,
  template: string,
  isEvent: bool
};

export default StoryCard;
